import axios from 'axios';

export default {
    methods: {
        async fleteSeguroIndex(d, ok, err) {
            try {
                let r = await axios.get('flete/seguro?page=' + d.page, {params: d})
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async fleteSeguroStore(d, ok, err) {
            try {
                let r = await axios.post('flete/seguro', d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async fleteSeguroUpdate(id, d, ok, err) {
            try {
                let r = await axios.put('flete/seguro/' + id, d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async fleteSeguroShow(id, ok, err) {
            try {
                let r = await axios.get('flete/seguro/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async fleteSeguroDestroy(id, ok, err) {
            try {
                let r = await axios.delete('flete/seguro/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/flete_seguro.js